import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import ObjectHelper from 'helpers/object'
import * as ApiRoute from 'constants/apiRouting'
import {
  FETCH_FEED_AMOUNT_CHART_DATA,
  SET_FEED_AMOUNT_CHART_DATA,
  FETCH_ACTUAL_EXPECTED_CHART_DATA,
  SET_ACTUAL_EXPECTED_CHART_DATA,
  FETCH_CAGES_LIST,
  SET_CAGES_LIST,
  FETCH_USER_LIST,
  SET_USER_LIST,
  SET_CAGE_RATE,
  FETCH_CAGES_RATE_LIST,
  SET_CAGES_RATE_LIST,
  FETCH_SITE_SENSORS,
  SET_SITE_SENSORS,
  FETCH_SITE_AVE_DATA,
  SUCCESS_SITE_AVE_DATA,
  FAILURE_SITE_AVE_DATA,
  FETCH_CAGE_AVE_DATA,
  SUCCESS_CAGE_AVE_DATA,
  FAILURE_CAGE_AVE_DATA,
  FETCH_SITE_SFR_DATA,
  SUCCESS_SITE_SFR_DATA,
  FAILURE_SITE_SFR_DATA,
  FETCH_CAGE_SFR_DATA,
  SUCCESS_CAGE_SFR_DATA,
  FAILURE_CAGE_SFR_DATA,
  FETCH_SITE_DLF_DATA,
  SUCCESS_SITE_DLF_DATA,
  FAILURE_SITE_DLF_DATA,
  FETCH_SILO_DLF_DATA,
  SUCCESS_SILO_DLF_DATA,
  FAILURE_SILO_DLF_DATA,
  FAILURE_CAGES_RATE_LIST,
} from './reducer'

function* fetchCageList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SLA_GET_CAGES, action.payload),
    })

    yield put({
      type: SET_CAGES_LIST,
      payload: {
        list: response,
      },
    })
  } catch (error) {
    console.log('SLA MONITOR FAILED ', error)
  }
}

function* fetchCageRateList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SLA_GET_CAGE_RATES, action.payload),
    })

    yield put({
      type: SET_CAGES_RATE_LIST,
      payload: {
        list: response,
      },
    })
  } catch (error) {
    console.log('SLA MONITOR FAILED ', error)
    yield put({
      type: FAILURE_CAGES_RATE_LIST,
    })
  }
}

function* fetchSiteSensors(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SLA_GET_SITE_SENSORS, action.payload),
    })

    yield put({
      type: SET_SITE_SENSORS,
      payload: {
        list: response,
      },
    })
  } catch (error) {
    console.log('SLA MONITOR FAILED ', error)
  }
}

function* fetchUserList() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRoute.USER_LIST_BY_LICENSEE,
    })

    yield put({
      type: SET_USER_LIST,
      payload: {
        list: ObjectHelper.mapList(response, ['id', 'name']),
      },
    })
  } catch (error) {
    console.log('SLA MONITOR FAILED ', error)
  }
}

function* fetchFeedAmountData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SLA_FEED_AMOUNT, action.payload),
    })

    yield put({
      type: SET_FEED_AMOUNT_CHART_DATA,
      payload: {
        data: response,
      },
    })
  } catch (error) {
    console.log('FETCH CHART DATA FAILED ', error)
  }
}

function* fetchActualExpectedData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        ApiRoute.SLA_CHART_FEEDING_ACTUAL,
        action.payload,
      ),
    })

    yield put({
      type: SET_ACTUAL_EXPECTED_CHART_DATA,
      payload: {
        data: response,
      },
    })
  } catch (error) {
    console.log('FETCH CHART DATA FAILED ', error)
  }
}

function* setCageRate(action) {
  try {
    const { params, values } = action.payload
    yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'POST',
      partUrl: UrlHelper.create(ApiRoute.SLA_SET_CAGE_RATE, params),
      data: values,
    })

    return yield call(action.promise.resolve, false)
  } catch (error) {
    throw new Error(`UNKNOWN LOCUS CHANGE ERROR. DATA: ${error}`)
  }
}

// function* fetchSiteTFAData(action) {
//     try {
//         const response = yield call(fetchFromAPI, {
//             headers: getDefaultAutorizedHeaders(),
//             partUrl: UrlHelper.create(ApiRoute.SITE_TOTAL_FEED, action.payload),
//         });
//
//         if(!response.hasOwnProperty('error')) {
//             yield put({type: SUCCESS_SITE_TFA_DATA, payload: response});
//         } else {
//             yield put({type: FAILURE_SITE_TFA_DATA});
//         }
//     } catch (error) {
//         console.log('SLA SITE TFA FAILED', error);
//     }
// }
// function* fetchCageTFAData(action) {
//     try {
//         const response = yield call(fetchFromAPI, {
//             headers: getDefaultAutorizedHeaders(),
//             partUrl: UrlHelper.create(ApiRoute.CAGE_TOTAL_FEED, action.payload),
//         });
//
//         if(!response.hasOwnProperty('error')) {
//             yield put({type: SUCCESS_CAGE_TFA_DATA, payload: response});
//         } else {
//             yield put({type: FAILURE_CAGE_TFA_DATA});
//         }
//     } catch (error) { console.log('SLA CAGE TFA FAILED ', error); }
// }

function* fetchSiteAvEData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        ApiRoute.SITE_FEED_ACTUAL_EXPECTED,
        action.payload,
      ),
    })

    if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
      yield put({ type: SUCCESS_SITE_AVE_DATA, payload: response })
    } else {
      yield put({ type: FAILURE_SITE_AVE_DATA })
    }
  } catch (error) {
    console.log('SLA SITE AVE FAILED', error)
    yield put({ type: FAILURE_SITE_AVE_DATA })
  }
}
function* fetchCageAvEData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        ApiRoute.CAGE_FEED_ACTUAL_EXPECTED,
        action.payload,
      ),
    })

    if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
      yield put({
        type: SUCCESS_CAGE_AVE_DATA,
        payload: {
          ...action.payload.locus,
          last_updated: response.last_updated,
          data: response.data,
        },
      })
    } else {
      yield put({ type: FAILURE_CAGE_AVE_DATA })
    }
  } catch (error) {
    console.log('SLA CAGE AVE FAILED ', error)
    yield put({ type: FAILURE_CAGE_AVE_DATA })
  }
}

function* fetchSiteSFRData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SITE_SFR_CORRECTED, action.payload),
    })

    if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
      yield put({ type: SUCCESS_SITE_SFR_DATA, payload: response })
    } else {
      yield put({ type: FAILURE_SITE_SFR_DATA })
    }
  } catch (error) {
    console.log('SLA SITE SFR FAILED', error)
    yield put({ type: FAILURE_SITE_SFR_DATA })
  }
}
function* fetchCageSFRData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.CAGE_SFR_CORRECTED, action.payload),
    })

    if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
      yield put({
        type: SUCCESS_CAGE_SFR_DATA,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_CAGE_SFR_DATA })
    }
  } catch (error) {
    console.log('SLA CAGE SFR FAILED ', error)
    yield put({ type: FAILURE_CAGE_SFR_DATA })
  }
}

function* fetchSiteDLFData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SITE_LEFT_FEEDING, action.payload),
    })

    if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
      yield put({ type: SUCCESS_SITE_DLF_DATA, payload: response })
    } else {
      yield put({ type: FAILURE_SITE_DLF_DATA })
    }
  } catch (error) {
    console.log('SLA SITE DLF FAILED', error)
    yield put({ type: FAILURE_SITE_DLF_DATA })
  }
}

function* fetchSiloDLFData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SILO_LEFT_FEEDING, action.payload),
    })

    if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
      yield put({ type: SUCCESS_SILO_DLF_DATA, payload: response })
    } else {
      yield put({ type: FAILURE_SILO_DLF_DATA })
    }
  } catch (error) {
    console.log('SLA SILO DLF FAILED ', error)
    yield put({ type: FAILURE_SILO_DLF_DATA })
  }
}

function* slaMonitorSaga() {
  yield takeLatest(FETCH_FEED_AMOUNT_CHART_DATA, fetchFeedAmountData)
  yield takeLatest(FETCH_ACTUAL_EXPECTED_CHART_DATA, fetchActualExpectedData)
  yield takeLatest(FETCH_CAGES_LIST, fetchCageList)
  yield takeLatest(FETCH_CAGES_RATE_LIST, fetchCageRateList)
  yield takeLatest(FETCH_USER_LIST, fetchUserList)
  yield takeLatest(SET_CAGE_RATE, setCageRate)
  yield takeLatest(FETCH_SITE_SENSORS, fetchSiteSensors)
  // yield takeLatest(FETCH_SITE_TFA_DATA, fetchSiteTFAData);
  // yield takeLatest(FETCH_CAGE_TFA_DATA, fetchCageTFAData);
  yield takeLatest(FETCH_SITE_AVE_DATA, fetchSiteAvEData)
  yield takeLatest(FETCH_CAGE_AVE_DATA, fetchCageAvEData)
  yield takeLatest(FETCH_SITE_SFR_DATA, fetchSiteSFRData)
  yield takeLatest(FETCH_CAGE_SFR_DATA, fetchCageSFRData)
  yield takeLatest(FETCH_SITE_DLF_DATA, fetchSiteDLFData)
  yield takeLatest(FETCH_SILO_DLF_DATA, fetchSiloDLFData)
}

export default slaMonitorSaga
